import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import "./index.css";
import { AuthProvider, useAuth } from "./auth/AuthProvider";
import { createAppRouter } from "./router";
import { initSentry } from "./sentry";

initSentry();

const router = createAppRouter();

// The router needs the live auth value, and useAuth only works inside AuthProvider — so the
// provider wraps a component that reads it and hands it to the router as context.
// The QueryClient and its persisted store are created per signed-in session, inside the
// _authed route — see BoardSession there for why they can't be app-wide singletons.
function AppRouter() {
  const auth = useAuth();
  return <RouterProvider router={router} context={{ auth }} />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  </StrictMode>,
);
